import { startOfDay, endOfDay, subDays, startOfWeek, endOfWeek, subWeeks, startOfMonth, endOfMonth, subMonths, startOfYear, endOfYear, subYears, isSameDay, } from 'date-fns';
var setCurrent = function (startFunc, endFunc) {
    var start = startFunc(new Date());
    var end = endFunc(new Date());
    return { start: start, end: end };
};
var setLast = function (startFunc, endFunc, reducer) {
    var start = startFunc(reducer(new Date(), 1));
    var end = endFunc(reducer(new Date(), 1));
    return { start: start, end: end };
};
var setCustomLast = function (startFunc, endFunc, reducer, amount) {
    if (amount === void 0) { amount = 0; }
    var start = startFunc(reducer(new Date(), amount));
    var end = endFunc(new Date());
    return { start: start, end: end };
};
var setToDate = function (startFunc) {
    var start = startFunc(new Date());
    var end = new Date();
    return { start: start, end: end };
};
export var CUSTOM_RANGES = [
    {
        label: 'Today',
        setter: function () { return setCurrent(startOfDay, endOfDay); },
    },
    {
        label: 'Yesterday',
        setter: function () { return setLast(startOfDay, endOfDay, subDays); },
    },
    {
        label: 'This Week',
        setter: function () { return setCurrent(startOfWeek, endOfWeek); },
    },
    {
        label: 'Last Week',
        setter: function () { return setLast(startOfWeek, endOfWeek, subWeeks); },
    },
    {
        label: 'Last 7 days',
        setter: function () { return setCustomLast(startOfDay, endOfDay, subDays, 6); },
    },
    {
        label: 'Month to date',
        setter: function () { return setToDate(startOfMonth); },
    },
    {
        label: 'Previous Month',
        setter: function () { return setLast(startOfMonth, endOfMonth, subMonths); },
    },
    {
        label: 'Last 30 days',
        setter: function () { return setCustomLast(startOfDay, endOfDay, subDays, 29); },
    },
    {
        label: 'Last 90 days',
        setter: function () { return setCustomLast(startOfDay, endOfDay, subDays, 89); },
    },
    {
        label: 'Last 6 months',
        setter: function () { return setCustomLast(startOfDay, endOfDay, subMonths, 6); },
    },
    {
        label: 'Last 12 months',
        setter: function () { return setCustomLast(startOfDay, endOfDay, subMonths, 12); },
    },
    {
        label: 'Year to date',
        setter: function () { return setToDate(startOfYear); },
    },
    {
        label: 'Previous Year',
        setter: function () { return setLast(startOfYear, endOfYear, subYears); },
    },
];
export var getActiveRange = function (startDate, endDate) {
    return CUSTOM_RANGES.find(function (r) { return isSameDay(r.setter().start, startDate) && isSameDay(r.setter().end, endDate); });
};
//# sourceMappingURL=customRanges.js.map